export const placementAllKey = 'placementAll';
export const placementAllListKey = 'placementAllList';
export const placementNoAccountKey = 'placementNoAccount';
export const placementNoAccountListKey = 'placementNoAccountList';
export const getPlacementKey = 'getPlacement';
export const getPlacementListKey = 'getPlacementList';
export const deletePlacementKey = 'deletePlacement';
export const editPlacementKey = 'editPlacement';
export const updatePlacementKey = 'updatePlacement';
export const addPlacementKey = 'addPlacement';
